import styled, { css } from "styled-components";
import { pageGutterSpace } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import { spacingSpace } from "../SectionOrg/SectionOrg.settings";
import { getSpacingSpaceValue } from "../SectionOrg/SectionOrg.styled";
import { sizesSpace } from ".";
export var getNegativeMarginsStyles = function getNegativeMarginsStyles(margins) {
  var topSpacingValue = spacingSpace[margins.top];
  var bottomSpacingValue = spacingSpace[margins.bottom];
  return css(["margin-top:-", ";margin-bottom:-", ";", "{margin-top:-", ";margin-bottom:-", ";}", "{margin-top:-", ";margin-bottom:-", ";}"], getSpacingSpaceValue(topSpacingValue, "small"), getSpacingSpaceValue(bottomSpacingValue, "small"), breakpoint("medium"), getSpacingSpaceValue(topSpacingValue, "medium"), getSpacingSpaceValue(bottomSpacingValue, "medium"), breakpoint("large"), getSpacingSpaceValue(topSpacingValue, "large"), getSpacingSpaceValue(bottomSpacingValue, "large"));
};
export var StyledContainerOrg = styled.div.withConfig({
  componentId: "sc-smzagw-0"
})(function (_ref) {
  var $width = _ref.$width,
    $isFullWidth = _ref.$isFullWidth,
    $isFullWidthOnMobile = _ref.$isFullWidthOnMobile,
    $negativeMargins = _ref.$negativeMargins;
  return css(["width:100%;max-width:", ";margin:0 auto;padding:0 ", ";", " ", "{", "}", ";"], space(sizesSpace[$width] + pageGutterSpace * 2), space(pageGutterSpace), $isFullWidth && css(["max-width:", ";padding:0;"], space(220)), breakpoint("small", "large"), $isFullWidthOnMobile && css(["width:100%;max-width:", ";padding:0;"], space(220)), getNegativeMarginsStyles($negativeMargins));
});